import { render, staticRenderFns } from "./ServiceProvidedSwitch.vue?vue&type=template&id=8dab94b0&"
import script from "./ServiceProvidedSwitch.vue?vue&type=script&lang=js&"
export * from "./ServiceProvidedSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProvidedSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
